<template>
  <div class="input-wrap">
    <div class="error_area">
      <p>{{ result }}</p>
    </div>
    <div class="input-wrap">
      <label :for="keyName">{{ title }}</label>
      <p class="input-description">{{ description }}</p>
      <input
        type="tel"
        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
        maxlength="8"
        class="form-control"
        :class="[result === null || result === '' ? '' : 'form_error']"
        :id="keyName"
        :name="keyName"
        :placeholder="placeholder"
        :value="value"
        @blur="handleAutoAddress($event.target.value)"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      address: null,
      result: null,
    }
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    keyName: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
    },
    value: {
      type: String,
      required: false,
    },
    description: {
      type: String,
      required: false,
    },
  },
  methods: {
    async handleAutoAddress(value) {
      if (value === '') return
      await this.$emit('input-emit', this.keyName, value)
      const url = `https://dayrobo.github.io/jp-postal-code-api/docs/api/v1/${value}.json`
      await axios
        .get(url, {})
        .then(res => {
          const responseData = res.data.addresses[0]
          const prefcode = Number(responseData.prefectureCode)
          const jaAddress = responseData.ja
          this.address = {
            prefcode: prefcode ? String(prefcode) : '0',
            ja: jaAddress,
          }
          this.result = ''
          this.$emit('auto-address', this.address)
        })
        .catch(err => {
          if (value.length > 0) {
            this.result =
              '該当する住所が無いか、正しい形式で入力されていません。'
          } else {
            this.result = ''
          }
          console.log(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.error_area {
  p {
    color: red;
    margin: 0;
  }
}
input[type='tel']::-webkit-outer-spin-button,
input[type='tel']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type='tel'] {
  -moz-appearance: textfield;
  margin: 10px auto 0;
  width: 100%;
  border: 1px solid #d8dbe0;
  border-radius: 5px;
  padding: 0.375rem 0.75rem;
  font-size: 14px;
}

input[type='tel'].form_error {
  border: 2px solid red;
}
.input-wrap {
  max-width: 140px;
}
</style>
